const Home = () => {
    
    return ( 
        <div 
        className="container-fluid d-flex align-items-center justify-content-center vh-100"
      >
        <div className="text-center p-4 rounded bg-white shadow-sm" style={{ maxWidth: '500px', backdropFilter: 'blur(5px)', opacity: 0.9 }}>
          <h1 className="display-4 text-primary mb-3">EyeconX</h1>
          <p className="lead text-muted mb-4">
          EyeconX enables your practice to effortlessly and instantly send reminders, recalls, notifications and education to patients via e-mail, SMS and telephone.
          </p>
            </div>
      </div>
     );
}
 
export default Home;